<template>
  <div>
    <!-- Edit -->
    <a-modal v-model="visible" title="Edit User Details" onOk="handleOk">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleEdit">Update User</a-button>
      </template>
      <a-spin :spinning="spinning">
        <a-form :form="form">
          <div class="row mb-0">
            <div class="col-md-6">
              <a-form-item label="First Name">
                <a-input
                  placeholder="First name"
                  v-decorator="['first_name', {rules: [{ required: true, message: 'Please input first name!' }]}]"
                />
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Last Name">
                <a-input
                  placeholder="Last name"
                  v-decorator="['last_name', {rules: [{ required: true, message: 'Please input last name!' }]}]"
                />
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Email">
                <a-input
                  placeholder="Email"
                  v-decorator="[
                    'email',
                    {
                      rules: [{
                        type: 'email', message: 'The input is not valid email!',
                      }, {
                        required: true, message: 'Please input an email!',
                      }]
                    }
                  ]"
                  :disabled="true"
                />
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Phone">
                <a-input
                  placeholder="Phone"
                  v-decorator="['phone', {rules: [{ required: true, message: 'Please input a valid phone!', pattern: new RegExp(`^[0-9]{7,14}$`) }]}]"
                  width="100%"
                >
                <a-select
                    slot="addonBefore"
                    v-decorator="[
                      'country_code',
                      { initialValue: '91' }
                    ]"
                    style="width: 70px"
                  >
                    <a-select-option v-for="countryCode in countryCodes" :value="countryCode.value" :key="countryCode.value">
                      <span class="text-bold">{{countryCode.name}}</span>
                    </a-select-option>
                  </a-select>
                </a-input>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Role">
                <a-select
                  placeholder="Select role"
                  optionFilterProp="children"
                  style="width: 220px"
                  :filterOption="false"
                  v-decorator="['role', {rules: [{ required: true, message: 'Please select a role' },], initialValue: 'supervisor'}]"
                >
                <template v-for="role in userRoles">
                  <a-select-option :key="role.value"
                  :value="role.value">
                    {{ role.name }}
                  </a-select-option>
                </template>
                </a-select>
              </a-form-item>
            </div>
            <div class="col-md-6"></div>
            <div class="col-md-6">
              <a-form-item label="Password">
                <a-input-password
                  v-decorator="[
                    'password',
                    {
                      rules: [{
                        required: changePassword, message: 'Please input a password!',
                      }, {
                        validator: validateToNextPassword,
                      }],
                    }
                  ]"
                  type="password"
                  :disabled="!changePassword"
                />
              </a-form-item>

              <a-button type="link" class="pl-0" @click="changePasswordHandler">{{ changePassword ? 'Disable changing password' : 'Click here to Change password'}}</a-button>
            </div>
            <div class="col-md-6">
              <a-form-item label="Confirm Password" has-feedback>
                <a-input-password
                  v-decorator="[
                    'confirm_password',
                    {
                      rules: [{
                        required: changePassword, message: 'Please confirm user password!',
                      }, {
                        validator: compareToFirstPassword,
                      }],
                    }
                  ]"
                  type="password"
                  @blur="handleConfirmBlur"
                  :disabled="!changePassword"
                />
              </a-form-item>
            </div>
          </div>
        </a-form>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import { countryCodes } from '@/services/globaldata'
import { userRoles } from '../data'
import { makeUserData } from '../fields'
import { mapValues } from 'lodash'

export default {
  name: 'EditUser',
  data: function() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      spinning: false,
      userId: null,
      countryCodes,
      userRoles,
      changePassword: false,
    }
  },
  mounted: function () {
    this.$eventBus.$on('openUserEditModal', this.showModal)
  },
  methods: {
    showModal: function(userId) {
      this.userId = userId
      this.visible = true
      this.loading = true
      this.spinning = true
      this.$http.get('/api/user/' + userId).then(({ data }) => {
        const userData = makeUserData(data.data)
        const fieldsData = mapValues({ ...userData }, function(value) {
          return value !== null ? value : undefined
        })
        this.form.setFieldsValue(fieldsData)
        this.spinning = false
        this.loading = false
      })
    },
    handleConfirmBlur (e) {
      const value = e.target.value
      this.confirmDirty = this.confirmDirty || !!value
    },
    compareToFirstPassword (rule, value, callback) {
      const form = this.form
      if (value && value !== form.getFieldValue('password')) {
        // eslint-disable-next-line standard/no-callback-literal
        callback('Not same with the password!')
      } else {
        callback()
      }
    },
    validateToNextPassword (rule, value, callback) {
      const form = this.form
      if (value && this.confirmDirty) {
        form.validateFields(['confirm_password'], { force: true })
      }
      callback()
    },
    changePasswordHandler () {
      this.changePassword = !this.changePassword
      this.form.resetFields(['password', 'confirm_password'])
    },
    handleEdit: function (e) {
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$confirm({
            title: `Are you sure?`,
            content: `Click on the OK button to update the user details!`,
            onOk: () => {
              let data = {
                'first_name': values.first_name,
                'last_name': values.last_name,
                'country_code': values.country_code,
                'phone': values.phone,
              }

              if (values.password) {
                data.password = values.password
              }

              this.$http
                .patch('/api/user/' + this.userId, data)
                .then(() => {
                  this.$emit('edited')
                  this.loading = false
                  this.visible = false
                  this.$notification['success']({
                    message: 'Successfully edited',
                    description: 'Class details edited successfully!',
                  })

                  this.form.resetFields()
                })
                .catch(error => {
                  this.loading = false
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
        }
      })
    },
    handleCancel(e) {
      this.visible = false
      this.form.resetFields()
    },
  },
}
</script>
